class InquiryHandler {
  constructor() {
    this.init();
  }

  init() {
    // Find all inquiry buttons
    this.bindInquiryButtons();
    
    // Initialize popup if exists
    this.initPopup();
    
    // Initialize clear buttons
    this.initClearButton();

    // Watch for dynamically added buttons
    this.observeDynamicButtons();
  }

  bindInquiryButtons() {
    const inquiryButtons = document.querySelectorAll('.inquire-btn');
    console.log('Found inquiry buttons:', inquiryButtons.length);
    
    inquiryButtons.forEach(button => {
      button.removeEventListener('click', this.handleClick);
      button.addEventListener('click', this.handleClick.bind(this));
    });
  }

  initClearButton() {
    const clearButtons = document.querySelectorAll('.clear-btn');
    console.log('Found clear buttons:', clearButtons.length);
    
    clearButtons.forEach(button => {
      button.removeEventListener('click', this.handleClear);
      button.addEventListener('click', this.handleClear.bind(this));
    });
  }

  handleClear(e) {
    e.preventDefault();
    const button = e.currentTarget;
    
    // Find the closest form
    const form = button.closest('form');
    
    if (form) {
      // Clear all input fields, textareas, and select elements
      const inputs = form.querySelectorAll('input:not([type="hidden"]), textarea, select');
      
      inputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });
      
      // Clear any error messages
      const errorMessages = form.querySelectorAll('.error-message');
      errorMessages.forEach(msg => msg.remove());
      
      // Remove error classes
      const errorInputs = form.querySelectorAll('.error');
      errorInputs.forEach(input => input.classList.remove('error'));
      
      console.log('Form cleared successfully');
    }
  }

  handleClick(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const behavior = button.getAttribute('data-behavior') || 'popup';
    const scrollTarget = button.getAttribute('data-scroll-target') || '#inquiry-form';
    const kartTitle = this.getKartTitle(button);
    const kartPrice = this.getKartPrice(button);
    
    console.log('Button clicked:', { behavior, scrollTarget, kartTitle, kartPrice });
    
    switch(behavior) {
      case 'popup':
        this.openPopup(kartTitle, kartPrice);
        break;
      case 'scroll':
        this.scrollToSection(scrollTarget, kartTitle, kartPrice);
        break;
      default:
        this.openPopup(kartTitle, kartPrice);
    }
  }

  getKartTitle(button) {
    // Try to get title from button's container
    const container = button.closest('.kart-hero-banner, .kart-card, [data-kart]');
    if (container) {
      const titleElement = container.querySelector('.kart-title, h1, h2, h3');
      if (titleElement) return titleElement.innerText.trim();
    }
    
    // Fallback to page title
    const pageTitle = document.querySelector('.kart-title, h1');
    return pageTitle ? pageTitle.innerText.trim() : document.title;
  }

  getKartPrice(button) {
    const dataPrice = button.getAttribute('data-price');
    if (dataPrice) {
      return dataPrice.trim().replace('From ', '').replace('$', '');
    }
    return '';
  }

  initPopup() {
    this.popup = document.querySelector('.inquiry-popup');
    if (!this.popup) return;
    
    this.closeBtn = this.popup.querySelector('.close-popup');
    this.overlay = this.popup.querySelector('.popup-overlay');
    this.popupForm = this.popup.querySelector('.inquiry-form');
    
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closePopup());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closePopup());
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('active')) {
        this.closePopup();
      }
    });
    
    if (this.popupForm) {
      this.popupForm.addEventListener('submit', (e) => this.handleFormSubmit(e, this.popupForm, this.popup));
    }
  }

  openPopup(kartTitle, kartPrice) {
    if (!this.popup) {
      console.warn('Popup not found on this page');
      return;
    }
    
    // Populate hidden fields
    const titleField = this.popup.querySelector('input[name="contact[kart_title]"]');
    const priceField = this.popup.querySelector('input[name="contact[kart_price]"]');
    const urlField = this.popup.querySelector('input[name="contact[kart_url]"]');
    
    if (titleField && kartTitle) titleField.value = kartTitle;
    if (priceField && kartPrice) priceField.value = `$${kartPrice}`;
    if (urlField) urlField.value = window.location.href;
    
    this.popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    if (!this.popup) return;
    this.popup.classList.remove('active');
    document.body.style.overflow = '';
    
    if (this.popupForm) {
      this.popupForm.reset();
      this.clearErrors(this.popupForm);
    }
  }

  scrollToSection(target, kartTitle, kartPrice, offset = 80) {
    const targetSection = document.querySelector(target);
    
    if (targetSection) {
      // Get the target element's position
      const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
      
      // Calculate scroll position with offset
      const scrollPosition = targetPosition - offset;
      
      // Scroll to the calculated position
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
      
      // Populate the form in the target section
      setTimeout(() => {
        this.populateScrollForm(targetSection, kartTitle, kartPrice);
      }, 500);
      
    } else {
      console.warn(`Target section "${target}" not found`);
    }
  }

  scrollAndOpenPopup(target, kartTitle, kartPrice) {
    this.scrollToSection(target, kartTitle, kartPrice);
    setTimeout(() => {
      this.openPopup(kartTitle, kartPrice);
    }, 800);
  }

  populateScrollForm(targetSection, kartTitle, kartPrice) {
    const titleField = targetSection.querySelector('input[name="contact[kart_title]"]');
    const priceField = targetSection.querySelector('input[name="contact[kart_price]"]');
    
    if (titleField && kartTitle) titleField.value = kartTitle;
    if (priceField && kartPrice) priceField.value = `$${kartPrice}`;
  }

  async handleFormSubmit(e, form, popup) {
    e.preventDefault();
    
    if (!this.validateForm(form)) return;
    
    const submitBtn = form.querySelector('.submit-btn');
    const originalText = submitBtn.textContent;
    
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';
    
    try {
      const formData = new FormData(form);
      const response = await fetch('/contact#contact_form', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      const successMsg = popup.querySelector('.success-message');
      if (successMsg) successMsg.style.display = 'block';
      
      form.reset();
      
      /*
      setTimeout(() => {
        this.closePopup();
      }, 3000);
      */
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error. Please try again or call us.');
      
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
  }

  validateForm(form) {
    let isValid = true;
    const nameInput = form.querySelector('input[name="contact[name]"]');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const termsCheckbox = form.querySelector('input[name="contact[terms]"]');
    
    this.clearErrors(form);
    
    if (nameInput && !nameInput.value.trim()) {
      this.showError(nameInput, 'Name is required');
      isValid = false;
    }
    
    if (emailInput && !emailInput.value.trim()) {
      this.showError(emailInput, 'Email is required');
      isValid = false;
    } else if (emailInput && !this.isValidEmail(emailInput.value)) {
      this.showError(emailInput, 'Valid email is required');
      isValid = false;
    }
    
    if (termsCheckbox && !termsCheckbox.checked) {
      this.showError(termsCheckbox, 'You must accept the terms');
      isValid = false;
    }
    
    return isValid;
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  showError(input, message) {
    input.classList.add('error');
    let errorMsg = input.parentElement.querySelector('.error-message');
    if (!errorMsg) {
      errorMsg = document.createElement('span');
      errorMsg.className = 'error-message';
      errorMsg.style.cssText = 'color: #ff0000; font-size: 12px; margin-top: 4px; display: block;';
      input.parentElement.appendChild(errorMsg);
    }
    errorMsg.textContent = message;
  }

  clearErrors(form) {
    form.querySelectorAll('.error').forEach(input => input.classList.remove('error'));
    form.querySelectorAll('.error-message').forEach(msg => msg.remove());
  }

  observeDynamicButtons() {
    const observer = new MutationObserver(() => {
      this.bindInquiryButtons();
      this.initClearButton();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  window.inquiryHandler = new InquiryHandler();
});